import { useDeleteTestimonial, useGetTestimonials } from "./use-testimonial";
import { TestimonialModel } from "../../data/models/testimonial-model";

const useTestimonialViewModel = () => {
  const { data: testimonials, isLoading: isGetTestimonialLoading } =
    useGetTestimonials();
  const { mutate: deleteTestimonial, isPending: isDeleteTestimonialLoading } =
    useDeleteTestimonial();

  const getAllTestimonials: TestimonialModel[] =
    testimonials?.data && Array.isArray(testimonials.data) ? testimonials.data : [];

  return {
    isGetTestimonialLoading,
    getAllTestimonials,
    deleteTestimonial,
    isDeleteTestimonialLoading,
  };
};

export default useTestimonialViewModel;
